export default "__VITE_ASSET__CV4S_s4m__"